import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { Modal, message } from 'antd'

const BindingWechat = (props) => {
  const navigate = useNavigate()
  const intervalRef = useRef(null)
  const [qrcode, setQrcode] = useState('')
  const [expired, setExpired] = useState(false)
  const [refreshing, setRefreshing] = useState('')

  useEffect(() => {
    let isMounted = true
    const fetchData = async () => {
      try {
        const response = await axios.post('/c/kf_c/wechatmp/qrcode', { 
          scene: 'bind' 
        })
        if (isMounted && response.errcode === 0) {
          setQrcode(response.data.qrcode_url)
          intervalRef.current = setInterval(async () => {
            const bindingResponse = await axios.post('/c/kf_c/wechatmp/binding', {
              identity: localStorage.getItem('userId'),
              ticket: response.data.ticket 
            })

            if (isMounted) {
              if (bindingResponse.errcode === 0) {
                clearInterval(intervalRef.current)
                props.isCancel()
                message.success('微信公众号绑定成功！')
              } else if (bindingResponse.errcode === 1) {
                clearInterval(intervalRef.current)
                setExpired(true)
              }
            }
          }, 1000)

          setTimeout(() => {
            if (isMounted) {
              clearInterval(intervalRef.current)
              setExpired(true)
            }
          }, 120000)
        }
      } catch (error) { }
    }
    fetchData()
    return () => {
      isMounted = false
      clearInterval(intervalRef.current)
    }
  }, [refreshing, navigate, props])

  const refreshQRCode = () => {
    setExpired(false)
    setRefreshing(Math.random())
  }

  return (
    <>
      <Modal 
        destroyOnClose={true}
        title="开启消息通知"
        footer=''
        open={props.isOpen}
        onCancel={props.isCancel}>
        
        <div className='qrcode-container'>
          <div className='qrcode'>
            <img src={qrcode} alt="" />
          </div>
          {expired && (
            <div className='qrOverlay' onClick={refreshQRCode}>
              <p>二维码已过期，<span style={{ color: '#005dff' }}>刷新</span></p>
            </div>
          )}
          <p>长按关注公众号</p>
        </div>
      </Modal>
    </>    
  )
}

export default BindingWechat
